<template>
  <div class="digital-advertising">
    <div class='digital-advertising__wrapper'>
      <div class="digital-advertising__wrapper__title">
        <p>Choose your type of ads</p>
      </div>
      <div class="digital-advertising__wrapper__content">
        <div v-for="(item, index) in contents" :key="index" :class="['digital-advertising__wrapper__content__box', selected == index ? 'selected' : '']" @click.stop="click(index)">
          <div class="image" :style="{ backgroundImage : 'url(' + item.image + ')' }"></div>
          <p>{{ item.title }}</p>
        </div>
      </div>
      <div class="digital-advertising__wrapper__description">
        <h1>{{ contents[selected].header }}</h1>
        <div class="wrapper"><p>{{ contents[selected].description }}</p></div>
      </div>
      <div class="digital-advertising__wrapper__button">
        <button class="btn-regular primary" @click.stop="goTo">Continue</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'adx-digital-advertising',
  components: {

  },
  props: {

  },
  data() {
    return {
      selected: 0,
      contents: [
        {
          image: '/img/adxicon/ic-adwords.png',
          title: 'Google Adword',
          header: 'Iklan di Google Adwords',
          description: 'Memperkenalkan layanan iklan online Google Adwords yang mudah, murah, dan efisien.',
          link: 'adword'
        },
        {
          image: '/img/adxicon/ic-fb.png',
          title: 'Facebook & Instagram',
          header: 'Iklan di Facebook dan Instagram',
          description: 'Kini beriklan di facebook dan instagram semakin mudah, murah dan cepat. Saatnya perkenalkan produk ke lebih banyak orang di sosial media.',
          link: 'socmed'
        },
        {
          image: '/img/adxicon/ic-smsblast.png',
          title: 'SMS Blast',
          header: 'Paket SMS Blast',
          description: 'SMS Blast  memudahkan anda untuk terhubung dengan pelanggan yang sudah anda miliki. Anda bisa mengirimkan promo terbaru, memberikan info penambahan produk atau pesan apa saja.',
          link: 'smsblast'
        },
        {
          image: '/img/adxicon/ic-sms.png',
          title: 'SMS Targeted',
          header: 'Paket SMS Targeted',
          description: 'SMS Targeted Iklanku memudahkan untuk menjangkau pelanggan yang cocok dengan profil bisnis anda. Anda hanya perlu memasukan target yang ingin dijangkau, lokasi, minat dan operator.',
          link: 'smstargeted'
        },
      ]
    }
  },
  computed: {

  },
  watch: {
 
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
  
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    click(index) {
      this.selected = index
    },
    goTo() {
      this.$router.push({ name: this.contents[this.selected].link })
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>